export default __webpack_public_path__ + "a6304ffe9971e9df373791f20ed5ad9d.svg";